<div class="email-grado-container">
  <!-- Tarjeta de Encabezado / Selección -->
  <div class="row">
    <!-- Columna Izquierda: Redacción del Correo -->
    <div class="col-lg-6 col-md-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            <mat-icon color="primary">email</mat-icon>
            Redacción de Comunicado por Grado(s)
          </h4>

          <div class="form-group mb-3">
            <div class="d-flex justify-content-between align-items-center mb-1">
              <label class="form-label mb-0" for="gradosSelect">
                <b>1. Seleccionar Grados / Cursos:</b>
              </label>
              <div class="quick-grade-actions" *ngIf="grados.length > 0">
                <button
                  type="button"
                  class="btn btn-link btn-sm p-0 mr-2 text-primary font-12"
                  (click)="seleccionarTodosLosGrados()"
                  [disabled]="enviandoEmail || cargandoAlumnos"
                >
                  Seleccionar todos
                </button>
                <button
                  type="button"
                  class="btn btn-link btn-sm p-0 text-secondary font-12"
                  (click)="deseleccionarTodosLosGrados()"
                  [disabled]="enviandoEmail || cargandoAlumnos || gradosSeleccionadosIds.length === 0"
                >
                  Limpiar
                </button>
              </div>
            </div>

            <mat-form-field appearance="outline" class="w-100 grados-select-field">
              <mat-label>Seleccione uno o más grados...</mat-label>
              <mat-select
                id="gradosSelect"
                [(ngModel)]="gradosSeleccionadosIds"
                (selectionChange)="onGradosChange()"
                [disabled]="enviandoEmail"
                multiple
              >
                <mat-select-trigger>
                  <span *ngIf="gradosSeleccionadosIds.length === 1">
                    {{ gradosSeleccionados[0]?.descripcion || gradosSeleccionados[0]?.nombre }}
                  </span>
                  <span *ngIf="gradosSeleccionadosIds.length > 1" class="font-weight-bold">
                    {{ gradosSeleccionadosIds.length }} grados seleccionados
                  </span>
                </mat-select-trigger>

                <mat-option *ngFor="let g of grados" [value]="g.id">
                  {{ g.nombre }} - {{ g.descripcion }}
                </mat-option>
              </mat-select>
            </mat-form-field>

            <!-- Chips de Grados Seleccionados -->
            <div *ngIf="gradosSeleccionados.length > 0" class="selected-grados-chips">
              <span *ngFor="let g of gradosSeleccionados" class="grado-chip">
                <mat-icon class="grado-icon">school</mat-icon>
                <span>{{ g.descripcion || g.nombre }}</span>
                <mat-icon
                  class="remove-chip-icon"
                  *ngIf="!enviandoEmail"
                  (click)="removerGrado(g.id); $event.stopPropagation()"
                >cancel</mat-icon>
              </span>
            </div>
          </div>

          <!-- Métricas Rápidas del Grado -->
          <div *ngIf="alumnos.length > 0" class="stat-badge-box">
            <span class="stat-pill total">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px">people</mat-icon>
              Total Alumnos: <b>{{ totalAlumnos }}</b>
            </span>
            <span class="stat-pill valid">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px">mark_email_read</mat-icon>
              Con Email: <b>{{ totalConEmail }}</b>
            </span>
            <span *ngIf="totalSinEmail > 0" class="stat-pill invalid">
              <mat-icon style="font-size: 16px; width: 16px; height: 16px">error_outline</mat-icon>
              Sin Email: <b>{{ totalSinEmail }}</b>
            </span>
          </div>

          <!-- Asunto del Email -->
          <div class="form-group mb-3">
            <label class="form-label" for="asuntoInput">
              <b>2. Asunto del Correo (Subject):</b>
            </label>
            <input
              type="text"
              id="asuntoInput"
              class="form-control"
              placeholder="Ej: Comunicado importante - Reunión de padres"
              [(ngModel)]="asunto"
              [disabled]="enviandoEmail"
              required
            />
          </div>

          <!-- Cuerpo del Email -->
          <div class="form-group mb-2">
            <label class="form-label" for="cuerpoTextarea">
              <b>3. Mensaje / Cuerpo del Correo (Body):</b>
            </label>
            <textarea
              id="cuerpoTextarea"
              class="form-control"
              rows="7"
              placeholder="Escribe aquí el contenido del comunicado..."
              [(ngModel)]="cuerpo"
              [disabled]="enviandoEmail"
              required
            ></textarea>
          </div>

          <!-- Resumen de Destinatarios en Copia Oculta (BCC) -->
          <div *ngIf="emailsBCC.length > 0" class="mb-3">
            <label class="form-label d-flex justify-content-between align-items-center">
              <span>
                <b>Destinatarios en Copia Oculta (BCC):</b>
                <span class="badge badge-info ml-1">{{ emailsBCC.length }} correos ({{ destinatariosSeleccionados.length }} alumnos)</span>
              </span>
            </label>
            <div class="bcc-box">
              <span *ngFor="let mail of emailsBCC" class="email-chip">
                {{ mail }}
              </span>
            </div>
          </div>

          <!-- Botones de Acción -->
          <div class="action-buttons">
            <button
              type="button"
              class="btn btn-secondary mr-2"
              (click)="limpiarFormulario()"
              [disabled]="enviandoEmail"
            >
              <mat-icon style="vertical-align: middle">refresh</mat-icon>
              Limpiar
            </button>

            <button
              type="button"
              class="btn btn-primary"
              (click)="enviarEmailPorGrado()"
              [disabled]="
                enviandoEmail ||
                totalAlumnosSeleccionados === 0 ||
                destinatariosSeleccionados.length === 0 ||
                emailsBCC.length === 0 ||
                !asunto ||
                !asunto.trim() ||
                !cuerpo ||
                !cuerpo.trim()
              "
            >
              <span
                *ngIf="enviandoEmail"
                class="spinner-border spinner-border-sm mr-1"
                role="status"
                aria-hidden="true"
              ></span>
              <mat-icon *ngIf="!enviandoEmail" style="vertical-align: middle">send</mat-icon>
              {{ enviandoEmail ? 'Enviando correos...' : 'Enviar Email por Grado(s)' }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Columna Derecha: Alumnos del Grado & Log -->
    <div class="col-lg-6 col-md-12">
      <!-- Tabla de Alumnos -->
      <div class="card mb-3">
        <div class="card-body">
          <div class="d-flex justify-content-between align-items-center mb-3">
            <h4 class="card-title mb-0">
              <mat-icon color="accent">group</mat-icon>
              Alumnos
              <span class="badge badge-light ml-2 font-12" *ngIf="alumnos.length > 0">
                {{ destinatariosSeleccionados.length }} / {{ totalConEmail }} seleccionados
              </span>
            </h4>
            <button
              *ngIf="alumnos.length > 0 && totalConEmail > 0"
              type="button"
              class="btn btn-sm btn-outline-primary"
              (click)="toggleSeleccionarTodos()"
              [disabled]="enviandoEmail"
            >
              {{ todosSeleccionados ? 'Deseleccionar Todos' : 'Seleccionar Todos con Email' }}
            </button>
          </div>

          <div *ngIf="cargandoAlumnos" class="text-center py-4">
            <div class="spinner-border text-primary" role="status">
              <span class="sr-only">Cargando alumnos...</span>
            </div>
            <p class="mt-2 text-muted">Cargando lista de alumnos de los grados seleccionados...</p>
          </div>

          <div *ngIf="!cargandoAlumnos && alumnos.length === 0" class="text-center py-4 text-muted">
            <mat-icon style="font-size: 40px; width: 40px; height: 40px; color: #94a3b8">
              school
            </mat-icon>
            <p class="mt-2">
              Selecciona uno o más grados para ver y gestionar la lista de destinatarios.
            </p>
          </div>

          <div *ngIf="!cargandoAlumnos && alumnos.length > 0" class="table-alumnos-container">
            <table class="table-alumnos table table-sm table-hover">
              <thead>
                <tr>
                  <th style="width: 45px; text-align: center; vertical-align: middle">
                    <mat-checkbox
                      color="primary"
                      [checked]="todosSeleccionados"
                      (change)="toggleSeleccionarTodos($event)"
                      [disabled]="enviandoEmail || totalConEmail === 0"
                    >
                    </mat-checkbox>
                  </th>
                  <th>Grado</th>
                  <th>Legajo</th>
                  <th>Alumno</th>
                  <th>Correo Electrónico</th>
                  <th style="text-align: center">Estado</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let al of alumnos"
                  [ngClass]="{ 'no-email': !al.eMail || al.eMail.trim() === '' }"
                >
                  <td style="text-align: center; vertical-align: middle">
                    <mat-checkbox
                      color="primary"
                      [(ngModel)]="al.seleccionado"
                      (change)="onCheckboxIndividualChange()"
                      [disabled]="enviandoEmail || !al.eMail || al.eMail.trim() === ''"
                    >
                    </mat-checkbox>
                  </td>
                  <td>
                    <span class="badge badge-grado">
                      {{ al.grado?.descripcion || al.grado?.nombre || '-' }}
                    </span>
                  </td>
                  <td>{{ al.legajo || '-' }}</td>
                  <td>
                    <b>{{ al.apellido }}</b>, {{ al.nombre }}
                  </td>
                  <td>
                    <span *ngIf="al.eMail && al.eMail.trim() !== ''" class="text-primary font-12">
                      {{ al.eMail }}
                    </span>
                    <span *ngIf="!al.eMail || al.eMail.trim() === ''" class="text-muted font-12 font-italic">
                      Sin registrar
                    </span>
                  </td>
                  <td style="text-align: center">
                    <span
                      *ngIf="al.eMail && al.eMail.trim() !== ''"
                      class="badge badge-success"
                    >
                      Listo
                    </span>
                    <span
                      *ngIf="!al.eMail || al.eMail.trim() === ''"
                      class="badge badge-secondary"
                    >
                      Sin correo
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <!-- Registro y Log de Envío -->
      <div class="card">
        <div class="card-body">
          <h4 class="card-title">
            <mat-icon>terminal</mat-icon>
            Consola y Log del Proceso
          </h4>
          <textarea
            id="logEnvio"
            class="log-container form-control"
            [value]="logEnvio || 'Esperando inicio del proceso de envío...'"
            readonly
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
